// extracted by mini-css-extract-plugin
export default {"formLabel":"label_formLabel__tx-D3","big":"label_big__AJbPD"};